export const HOURLY_SURCHARGE = 500;
// TODO: We should retrieve these rather from the back (e.g. config)
export const PRESTATIONS_BASED_SURCHARGE = 1000;
// Only use this for internal price calculation, but not display
// TODO: This will only work as long as membership is 25% of original price
export const MEMBERSHIP_PRESTATIONS_BASED_SURCHARGE = 750;
